import { render, staticRenderFns } from "./categoryUpdate.vue?vue&type=template&id=1a9d4bb4&"
import script from "./categoryUpdate.vue?vue&type=script&lang=js&"
export * from "./categoryUpdate.vue?vue&type=script&lang=js&"
import style0 from "./categoryUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports